import React, { type ReactNode } from 'react';

import cx from '../../../utils/classNames';

import styles from '../button.module.scss';

/** Custom props */
type Props = {
  /** The content of the component */
  children?: ReactNode;
  /** Custom class to overwrite default styling if needed */
  className?: string;
} & React.HTMLAttributes<HTMLSpanElement>;

export function Icon(props: Props) {
  const { children, className, ...rest } = props;

  const classNames = cx(styles.buttonIcon, className);

  return (
    <span className={classNames} data-testid="button-icon" {...rest}>
      {children}
    </span>
  );
}

export default Icon;
